import { HttpErrorResponse } from '@angular/common/http';

export class HttpNotFoundException extends Error {}
export class HttpNoContentException extends Error {}
export class HttpUnauthorizedException extends Error {}
export class HttpServiceUnavailableException extends Error {}
export class HttpBadRequestException extends Error {}

export class HttpErrorUtil {
  public static sanitizeError(error: HttpErrorResponse) {
    if (error.status === 401) {
      return new HttpUnauthorizedException(error?.error?.Message);
    } else if (error.status === 400) {
      return new HttpBadRequestException(error?.error?.Message);
    } else if (error.status === 404) {
      return new HttpNotFoundException(error?.error?.Message);
    }
    return new HttpServiceUnavailableException(error?.error?.Message);
  }
}
